import StoreNav from './StoreNav';
import { fmtHolidayDate, buildReopenMessage } from '../lib/holiday';

export default function ClosedScreen({ holiday }) {
  const reopenMsg = buildReopenMessage(holiday);

  return (
    <div className="store" style={{ minHeight: '100vh' }}>
      <StoreNav />
      <div style={{ maxWidth: 520, margin: '0 auto', padding: '80px 24px 60px', textAlign: 'center' }}>
        <div style={{
          width: 72, height: 72, borderRadius: '50%', background: 'var(--primary-soft)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem',
          margin: '0 auto 24px',
        }}>
          🌴
        </div>

        <div style={{ fontSize: '.72rem', color: 'var(--primary)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 10 }}>
          Sedang Libur
        </div>
        <h1 style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1.6rem', color: 'var(--ink)', marginBottom: 14, lineHeight: 1.35 }}>
          {holiday?.reason?.trim() || 'Kami sedang libur hari ini'}
        </h1>
        <p style={{ fontSize: '.92rem', color: 'var(--ink-soft)', lineHeight: 1.7, marginBottom: 8 }}>
          Mohon maaf, untuk sementara kami belum bisa menerima pesanan.
        </p>
        {holiday?.date_from && holiday?.date_to && (
          <p style={{ fontSize: '.82rem', color: 'var(--ink-soft)', marginBottom: 4 }}>
            {holiday.date_from === holiday.date_to
              ? fmtHolidayDate(holiday.date_from)
              : `${fmtHolidayDate(holiday.date_from)} – ${fmtHolidayDate(holiday.date_to)}`}
          </p>
        )}
        {reopenMsg && (
          <p style={{ fontSize: '.92rem', color: 'var(--primary)', fontWeight: 600, marginTop: 18 }}>
            {reopenMsg}
          </p>
        )}
        <p style={{ fontSize: '.8rem', color: 'var(--ink-soft)', marginTop: 28 }}>
          Terima kasih sudah mampir, sampai jumpa lagi ya! 🙏
        </p>
      </div>
    </div>
  );
}
